import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FantasyGameDetailsV2, FantasyGameService, FantasyPlayer } from '@fgb/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { firstValueFrom } from 'rxjs';
import { ViewChild } from '@angular/core';
import { CarouselComponent } from 'ngx-owl-carousel-o';

@Component({
  selector: 'fgb-fantasy-player-select',
  templateUrl: './fantasy-player-select.component.html',
  styleUrl: './fantasy-player-select.component.scss',
})
export class FantasyPlayerSelectComponent implements OnChanges {
  @Input() gameId: number;
  @Input() gameDetails: FantasyGameDetailsV2;
  @Input() gameEnds: boolean = false;

  @ViewChild('owlCarousel', { static: false })
  owlCarousel!: CarouselComponent;

  currentCenterIndex = 0;
  pickedPlayerIndex = 0;
  pickedPlayer: FantasyPlayer | undefined = undefined;

  customOptions: OwlOptions = {
    items: 3,
    center: true,
    loop: true,
    autoWidth: false,
    startPosition: 0,

    pullDrag: false,
    mouseDrag: false,
    touchDrag: false,

    nav: true,
    dots: false,

    responsive: {
      0: {
        margin: 120,
      },
      400: {
        margin: 140,
      },
      992: {
        margin: 17,
      },
    },
  };

  constructor(private fantasyService: FantasyGameService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.gameDetails) {
      this.currentCenterIndex = 0;

      if (!this.gameDetails?.Players?.length) {
        return;
      }

      this.pickedPlayer = this.gameDetails.Players.find((x) => x.PlayerId === this.gameDetails.SelectedPlayerId);
    }
  }

  prev() {
    this.owlCarousel.prev();
  }

  next() {
    this.owlCarousel.next();
  }

  onTranslated(event: any) {
    const items = this.gameDetails.Players.length;

    // event.startPosition is the logical index (loop-safe)
    let index = event.startPosition;

    // normalize
    index = ((index % items) + items) % items;

    this.currentCenterIndex = index;
  }

  pickPlayer() {
    const selected = this.gameDetails.Players[this.currentCenterIndex];

    this.pickedPlayer = selected;

    firstValueFrom(this.fantasyService.confirmSelectionV2(this.gameId, selected.PlayerId));
  }

  editPick() {
    if (!this.pickedPlayer) return;

    const index = this.gameDetails.Players.findIndex((x) => x.PlayerId === this.pickedPlayer!.PlayerId);

    this.customOptions = {
      ...this.customOptions,
      startPosition: index,
    };

    this.currentCenterIndex = index;

    this.pickedPlayer = undefined;
    this.gameDetails.SelectedPlayerId = 0;
  }
}
